<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="pouringMethod" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" height="600" :border="true">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="Name" label="浇筑方式名称"></el-table-column>
      <el-table-column prop="Remark" label="备注" width="300"></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatDate" sortable></el-table-column>
      <el-table-column prop="CreateUser" label="创建者"></el-table-column>
      <el-table-column prop="Status" label="状态" width="">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status == 0 ? 'success' : 'info'" disable-transitions>
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canEdit" type="primary" @click="() => {
              currentRow = scope.row;
              handleEdit();
            }
            ">
            编辑
          </el-link>
          <el-link v-if="canDelete" type="danger" @click="() => {
              sels.push(scope.row);
              handleDel();
            }
            ">
            删除
          </el-link>
          <el-link type="primary" @click="() => {
              currentRow = scope.row;
              handleWorker();
            }
            ">
            当班司机
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
        <el-form-item label="浇筑方式名称" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="泵送" prop="IsPumping">
          <el-select v-model="editForm.IsPumping" placeholder="请选择状态">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input type="textarea" v-model="editForm.Remark" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
        <el-form-item label="浇筑方式名称" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="泵送" prop="IsPumping">
          <el-select v-model="addForm.IsPumping" placeholder="请选择状态">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input type="textarea" v-model="addForm.Remark" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 当班司机设置 -->
    <el-dialog title="新增" :visible.sync="workerFormVisible" v-model="workerFormVisible" :close-on-click-modal="false">
      <el-form :model="workerForm" label-width="120px" :rules="workerFormRules" ref="workerForm">
        <el-divider content-position="left">浇筑方式:{{ name }}</el-divider>
        <el-form>
          <el-row :gutter="20" type="flex" justify="space-around" class="row-center">
            <el-col>司机名称</el-col>
            <el-col>是否当班</el-col>
            <el-col>操作</el-col>
          </el-row>
          <el-row :gutter="20" type="flex" justify="space-around" v-for="(item, index) in workerForm.VehicleWorkers"
            :key="index">
            <el-col>
              <el-form-item>
                <el-select v-model="item.PumpingDriverID" @change="changeWorker(item.PumpingDriverID, index)">
                  <el-option v-for="hritem in hrEmployee" :label="hritem.Name" :key="hritem.Id" :value="hritem.Id"
                    v-model="hritem.Id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <template>
                <el-radio v-model="item.WorkerType" :label="1">是</el-radio>
                <el-radio v-model="item.WorkerType" :label="0">否</el-radio>
              </template>
            </el-col>
            <el-col>
              <el-form-item style="text-align: center">
                <el-button type="danger" @click="removeRow(item.Id)">
                  删除
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-button @click="addRow">新增行</el-button>
          </el-row>
        </el-form>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="workerFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="workerSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
//引入pouringMethod.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/pouringMethod";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { getHrEmployeeListPage } from "../../api/hrEmployee";
export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      pouringMethod: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [
          { required: true, message: "请输入浇筑方式名称", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        Name: "",
        Remark: "",
        Status: 0,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [
          { required: true, message: "请输入浇筑方式名称", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        Name: "",
        Remark: "",
      },
      name: "",
      hrEmployee: [], //所有司机字典
      workerFormVisible: false, //当班司机页面是否显示
      workerFormRules: {},
      workerForm: { PumpingId: "", VehicleWorkers: [] }, //当班司机列表
      subIndex: 0, //子条目Id
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getPouringMethod();
    },
    //获取浇筑方式列表
    getPouringMethod() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getPouringMethodListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.pouringMethod = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeletePouringMethod(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getPouringMethod();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateUser: "",
      };
    },
    //执行编辑
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          api
            .editPouringMethod(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getPouringMethod();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.editLoading = false;
            });
        }
      });
    },
    //执行新增
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          let para = Object.assign({}, this.addForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }

          api
            .addPouringMethod(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getPouringMethod();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getPouringMethod();
    },
    GetHrEmployeeList() {
      let para = {
        page: 1,
        intPageSize: 999,
      };
      getHrEmployeeListPage(para).then((res) => {
        this.hrEmployee = res.data.response.data;
        //获取所有司机后,查询此车现有当班司机
        this.GetPumpingWorker();
      });
    },
    //获取当班司机
    GetPumpingWorker() {
      let para = {
        key: this.workerForm.PumpingId,
      };
      api.getPumpingWorker(para).then((res) => {
        this.workerForm.VehicleWorkers = res.data.response.data;
      });
    },
    //当班司机页面打开
    handleWorker() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.workerFormVisible = true;
      this.workerForm.PumpingId = row.Id;
      this.name = row.Name;
      this.GetHrEmployeeList();
    },

    //当班司机添加行
    addRow() {
      this.subIndex += 1;
      this.workerForm.VehicleWorkers.push({ Id: this.subIndex, WorkerType: 0 });
    },
    removeRow(id) {
      this.workerForm.VehicleWorkers.splice(
        this.workerForm.VehicleWorkers.findIndex((x) => x.Id === id),
        1
      );
    },
    //选择司机
    changeWorker(Id, index) {
      var hrItem = this.hrEmployee.filter((x) => x.Id == Id)[0];
      this.workerForm.VehicleWorkers[index].PumpingDriverName = hrItem.Name;
      this.workerForm.VehicleWorkers[index].PumpingDriverID = Id;
    },
    //当班司机提交
    workerSubmit() {
      this.$refs.workerForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          let para = Object.assign({}, this.workerForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          api
            .postPumpingWorker(para)
            .then((res) => {
              debugger;
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["workerForm"].resetFields();
                this.workerFormVisible = false;
                this.getPouringMethod();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
  },
  mounted() {
    this.getPouringMethod();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped></style>
